webpackJsonp([6],{

/***/ 139:
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bd08c92","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Home.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../node_modules/css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bd08c92","scoped":true,"hasInlineConfig":false}!../../node_modules/sass-loader/lib/loader.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue */ 140);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../node_modules/vue-style-loader/lib/addStylesClient.js */ 53)("3c1ce7f9", content, true);

/***/ }),

/***/ 140:
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bd08c92","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Home.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../node_modules/css-loader/lib/css-base.js */ 52)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Home.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 141:
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Home.vue ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    articles: function articles() {
      return this.$store.state.news.slice(0, 2);
    }
  }
});

/***/ }),

/***/ 142:
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd08c92","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-content"},[_c('h1',{staticClass:"content_title-main"},[_vm._v("Новости")]),_vm._v(" "),_c('div',{staticClass:"homepage-blog_wrapper"},[_c('div',_vm._l((_vm.articles),function(article){return _c('div',{key:article.id,staticClass:"homepage-blog_article",attrs:{"id":article.id}},[_c('router-link',{staticClass:"homepage-blog_link article_image-container",attrs:{"to":'/news/' + article.id,"tag":"div"}},[_c('img',{staticClass:"homepage-blog_image",class:{ medium: article.isMedium, wide: article.isWide },attrs:{"src":article.imagesrc,"alt":"IMAGE"}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"body_text-plain",domProps:{"innerHTML":_vm._s(article.date)}}),_vm._v(" "),_c('router-link',{staticClass:"content_title-article",attrs:{"to":'/news/' + article.id,"tag":"h2"}},[_c('span',{staticClass:"content_article_link",domProps:{"innerHTML":_vm._s(article.title)}})]),_vm._v(" "),_c('p',{staticClass:"body_text-plain"},[_c('span',{domProps:{"innerHTML":_vm._s(article.content[0])}}),_vm._v(" "),_c('router-link',{staticClass:"body_text-plain content_article_link",attrs:{"to":'/news/' + article.id,"tag":"span"}},[_vm._v("\n                (...)\n              ")])],1)],1)],1)})),_vm._v(" "),_c('router-link',{staticClass:"homepage-blog_news-link body_text-plain",attrs:{"to":"/news","tag":"div"}},[_vm._v("Все новости")])],1),_vm._v(" "),_c('h1',{staticClass:"content_title-main"},[_vm._v("Об издательстве")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"content_title-main"},[_vm._v("Сотрудничество")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body_box"},[_c('p',{staticClass:"body_text-plain last"},[_vm._v("Издательство «Гамма-Пресс» специализируется на выпуске книг широкой гуманитарной тематики — музыка, театр, изобразительное искусство, архитектура, история, мемуары. Отдельное направление — книги-альбомы, многие из которых высоко оценены специалистами. Триумфом стало успешное прохождение конкурсного отбора среди тысячи книг от двух сотен российских издательств и получение Гран-при на Национальном конкурсе «Книга года — 2012» за двухтомник, посвящённый 100-летию ГМИИ имени Пушкина. На конкурсе «Книга года — 2013» издательство получило диплом в номинации HUMANITAS за фундаментальный труд О. С. Поповой «Пути византийского искусства».")]),_vm._v(" "),_c('p',{staticClass:"body_text-plain last"},[_vm._v("Не меньший общественный резонанс вызвали такие издания, как «Борис Пастернак: Биографический альбом», «Шимон Перес: Биография», «В сердцевине ада: Записки, найденные в пепле возле печей Освенцима» З. Градовского, историческая монография «Итальянская Россия» Н. Эйдельмана и Ю. Крелина, монография А. Пильгуна «Потусторонний мир Средневековья: рай, чистилище, ад и их персонажи в визионерских текстах и миниатюрах из западноевропейских рукописей IX–XV веков», ставшей продолжением его же бестселлера «Вселенная Средневековья».")]),_vm._v(" "),_c('p',{staticClass:"body_text-plain last"},[_vm._v("Также «Гамма-Пресс» работает в сотрудничестве со старейшими российскими издательствами «Музыка» и «П. Юргенсон»: как совместные издания вышли в свет популярная сегодня книга М. А. Зильберквита «Мир музыки» и биографическая серия «Жизнь великих композиторов».")]),_vm._v(" "),_c('p',{staticClass:"body_text-plain last"},[_vm._v("Среди новинок ассортимента — мемуары грузинского кинорежиссёра и сценариста Л. Л. Гогоберидзе «Что вспоминается и как вспоминается…», а также — в развитие направления детской литературы — сборник М. Садовского «Я буду музыкантом: весёлые стихи с картинками для малышей».")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body_box"},[_c('p',{staticClass:"body_text-plain last"},[_vm._v("Издательство «Гамма-Пресс» приглашает к сотрудничеству партнёров, а также принимает к рассмотрению рукописи для выпуска на коммерческой основе в качестве заказных изданий.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 54:
/*!*******************************!*\
  !*** ./client/views/Home.vue ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd08c92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6bd08c92","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 142);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6bd08c92","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 139)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bd08c92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd08c92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// 6.ec70441e.js